export const COACHING_LIST = [
  {
    name: 'NFT and FT Creation',
    description: 'Building sustainable organic economies with token Design'
  },
  {
    name: 'UX/UI Refinement',
    description: 'Get hands-on help from our professional designers to craft the perfect in-game experience.'
  },
  {
    name: 'Development Support',
    description:
      'Get ongoing support as you build your dream game or mod, or let us connect you with our expert devs to handle the coding for you.'
  },
  {
    name: 'Expert Testing',
    description:
      'Have your app or mod tested by those best fit to review it - expert play-to-earn gamers who live and breathe blockchain games.'
  },
  {
    name: 'Marketing Boost',
    description:
      'Grow your audience and reach by having your app recommended by Boxy, top creators, and top influencers on our streams and our gaming wallet.'
  },
  {
    name: 'Analytics',
    description: 'Get high-level insights into development progress using historical data and mentorship on A/B testing'
  },
  {
    name: 'Investment',
    description:
      'Our investment will help you kickstart your dream and will offer access to funding, technical support, and business expertise.'
  }
]
